export default function EyeOffIcon(props) {
  return (
    <svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.132 18.16l-.473.472-2.403-2.405-.283-.283-.34.215a8.624 8.624 0 01-4.632 1.34H10c-4.217 0-7.73-3.011-8.506-7.001a8.651 8.651 0 012.613-4.686l.87-.806L18.133 18.16zM6.106 7.928a4.666 4.666 0 006.467 6.466l-.275-.417.353-.353-1.22-1.22-.25-.25-.319.152a2.002 2.002 0 01-2.668-2.667l.154-.319-.251-.25-1.22-1.22-.433-.433-.338.51zM10 3.5c4.215 0 7.727 3.01 8.505 6.999a8.617 8.617 0 01-1.235 3.05l-2.622-2.621A4.667 4.667 0 009.57 5.85L7.565 3.846A8.678 8.678 0 0110 3.5zM4.917 4.945h-.943L1.868 2.84l.472-.472 2.577 2.577z"
        fill={props.fill}
        stroke={props.fill}
      />
    </svg>
  )
}
